import {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  nextPage,
  previousPage,
  selectPage,
  selectDataQuestions,
  questionAnswered,
  resetPage,
  selectDataComplete
} from "../features/data/dataSlice.js";
import dataIcon from "../assets/Navigation/nav_icon_quality_green.png";
import SideNav from "../components/SideNav";
import PageTitle from "../components/PageTitle";
import { Link } from "react-router-dom";
import SlideOut from "../components/SlideOut.js";
import riskStat from '../assets/Popups/popup_industry_stat_2-3.png'
import flowRates from '../assets/Popups/popup_production_graph.jpg'
import realTime from '../assets/Popups/popup_real-time_graph.jpg'
import rapidAdaptive from '../assets/Popups/popup_rapid_graph.jpg'
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Button, Container } from "@mui/material";

const Data = () => {
  const page = useSelector(selectPage);
  const dataQuestions = useSelector(selectDataQuestions)
  const dispatch = useDispatch();
  const section = {
    title: "Calidad de datos e información de producción",
    icon: dataIcon,
    pages: [1, 2, 3, 4, 5],
  };

  const isComplete = useSelector(selectDataComplete)
  useEffect(
    ()=>!isComplete ? dispatch(resetPage()):null,[]
  )


  const reduceRisk = {
    title: 'Reduzca el riesgo',
    copy: 'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede ayudar a su operación a reducir el riesgo y ayuda a evitar multas y daños a la reputación.',
    // bullets: ['Reduced dependency on workforce additions/reductions as operation grows/shrinks'],
    stat:{
      copy:`Reduzca su incertidumbre de medición hasta un 2-3 % con la tecnología de medición del caudal multifásica de Emerson.*`,
      graphic: riskStat
    }
  }
  const increaseConfidence = {
    title: 'Aumente la confianza',
    copy: 'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede proporcionar a su operación datos continuos y en tiempo real:',
    bullets: [<li>Optimizar la producción, el rendimiento de los pozos y el programa de intervención</li>,
              <li>Aumentar la confianza en las asignaciones</li>],
    view:{
      vert:true,
      copy:['Ver gráfico:',<br/>,'Velocidad del caudal/producción'],
      paragraph:['Con operaciones 100 % remotas, sin partes móviles y bajo consumo de energía, el MPFM Roxar 2600 de tamaño compacto es la solución de medición multifásica probada en el campo para ser utilizada en plataformas de pozos. '],
      graphic: flowRates
    }
  }
  const troubleshootQuicker = {
    title: 'Resolución de problemas rápida',
    copy: 'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede proporcionar a su operación datos continuos y en tiempo real:',
    bullets: [<li> Si se abordan las condiciones anormales con mayor rapidez, se reduce:</li>, <ul><li> Tiempo de inactividad</li><li> Pérdida de producción</li><li>Posibles daños en el caudal del depósito</li></ul>, 
    <li>Permitir la identificación de los problemas y la pronta resolución de los mismos y el análisis de la causa principal ANTES de enviar al personal de campo</li>],
    view:{
      vert:true,
      copy:['Ver gráfico:',<br/>,'Datos en tiempo real'],
      paragraph:['El medidor multifásico está respaldado por el software Fieldwatch, que permite el procesamiento posterior de los datos de medición para permitir la realización de pruebas de pozos sin disponer de datos PVT completos en el momento de realizar la prueba. Optimizar el flujo de trabajo y ahorrar costos y tiempo en el campo para la empresa de pruebas de pozos.'],
      graphic: realTime
    }
  }
  const reduceDowntime = {
    title: 'Reduzca las paradas imprevistas',
    copy: 'El uso del caudalímetro multifásico (MPFM) Roxar 2600 puede reducir el tiempo de parada imprevista:',
    bullets: [<li> Reducir el riesgo contractual y fiscal garantizando la calidad del producto</li>,
      <li>Supervisar la condición de activos con el diagnóstico de los contadores a bordo</li>],
    view:{
      vert:true,
      copy:['Ver software:',<br/>,'Rapid Adaptive'],
      paragraph:['Con operaciones 100% remotas, sin piezas móviles y bajo consumo de energía, tamaño compacto, el Roxar 2600 MPFM es la solución de medición multifásica comprobada en el campo para ser utilizada en plataformas de pozo.'],
      graphic: rapidAdaptive
    }
  }

  return (
    <Container className="content_container" maxWidth='lg'>
    <div className="roxar_content">
      <div className="main_content">
        <PageTitle section={section} currentPage={page} />
        <div className="page_contents">
          {page === 1 && (
            <div className="challenges"> 
              <div>
                <h1>Desafíos de producción</h1>
                <ul>
                  <li>
                  Separación ineficaz que provoca pérdidas de ingresos por caudal de gas/petróleo en el agua, agua en caudales de gas/petróleo

                  </li>
                  <li>
                  Tiempo para la resolución de problemas e identificar los modos de fallo
                  </li>
                  <li>
                  Sanciones contractuales/fiscales debidas a productos fuera de tolerancia
                  </li>
                  <li>
                  Falta de información completa para impulsar los planes de producción o intervención  
                  </li>
                  <li>
                  Contabilidad de asignación inexacta
                  </li>
                </ul>
              </div>
              <div className="solution_copy">
                <p>
                Mantener las especificaciones del producto y cumplir la normativa medioambiental puede ser un reto continuo. Los datos de producción en tiempo real proporcionados por el caudalímetro multifásico (MPFM) Roxar 2600 pueden ayudarle a anticiparse a los posibles problemas para poder solucionarlos a tiempo.
                </p>
                <Button className="forward_button production_button" onClick={() => dispatch(nextPage())}>Aprenda cómo</Button>
              </div>
            </div>
          )}
          {page === 2 && (
            <div className="questions">
              <div>
                  <h3 className="question">P: ¿Qué porcentaje de sus ingresos principales se pierde debido a las penalizaciones contractuales por productos fuera de especificación o por incumplimientos medioambientales?</h3>
                  <div className="answers short_answers">
                      <Button className={`answer ${dataQuestions[0].answer=='0%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'0%', score:5, max: 5}))}> 0% </Button>
                      <Button className={`answer ${dataQuestions[0].answer=='Menos de 1%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'Menos de 1%', score:4, max: 5}))}>Menos de 1%</Button>
                      <Button className={`answer ${dataQuestions[0].answer=='1-3%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'1-3%', score:3, max: 5}))}> 1-3%</Button>
                      <Button className={`answer ${dataQuestions[0].answer=='3-10%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'3-10%', score:2, max: 5}))}> 3-10%</Button>
                      <Button className={`answer ${dataQuestions[0].answer=='Más de 10%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'Más de 10%', score:1, max: 5}))}> Más de 10%</Button>
                  </div>
              </div>
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button" onClick={() => dispatch(nextPage())}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
            </div>
          )}
          {page === 3 && (
              <div className="questions">
              
                  <h3 className="question">P: ¿Cuál es la variación media entre la asignación de la producción de cada pozo y la producción global del arrendamiento/plataforma?</h3>
                  <div className="answers short_answers">
                  <Button className={`answer ${dataQuestions[1].answer=='1-5%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'1-5%', score:4, max: 4}))}> 1-5%</Button>
                  <Button className={`answer ${dataQuestions[1].answer=='5-10%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'5-10%', score:3, max: 4}))}> 5-10%</Button>
                  <Button className={`answer ${dataQuestions[1].answer=='10-15%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'10-15%', score:2, max: 4}))}> 10-15%</Button>
                  <Button className={`answer ${dataQuestions[1].answer=='Más de 15%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'Más de 15%', score:1, max: 4}))}>Más de 15%</Button>   
                  </div>
              
                  <h3 className="question">P: ¿Cuál es su variación ideal?</h3>
                  <div className="answers short_answers">
                  <Button className={`answer ${dataQuestions[2].answer=='1-5%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'1-5%', score:'1-5%' === dataQuestions[1].answer?4:2, max: 4}))}> 1-5%</Button>
                  <Button className={`answer ${dataQuestions[2].answer=='5-10%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'5-10%', score:'5-10%' === dataQuestions[1].answer?4:2, max: 4}))}> 5-10%</Button>
                  <Button className={`answer ${dataQuestions[2].answer=='10-15%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'10-15%', score:'10-15%' === dataQuestions[1].answer?4:2, max: 4}))}> 10-15%</Button>
                  <Button className={`answer ${dataQuestions[2].answer=='Más de 15%'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'Más de 15%', score:'Más de 15%' === dataQuestions[1].answer?4:2, max: 4}))}>Más de 15%</Button>   
                  </div>
           
              
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button" onClick={() => dispatch(nextPage())}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
            </div>
          )}
          {page === 4 && (
              <div className="questions"> 
                  <h3 className="question">P: ¿En qué plazo está previsto su actual ciclo de mantenimiento?</h3>
                  <div className="answers">
                  <Button className={`answer ${dataQuestions[3].answer=='De 1 a 3 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 1 a 3 semanas', score:1, max: 5}))}>De 1 a 3 semanas</Button>
                  <Button className={`answer ${dataQuestions[3].answer=='De 4 a 6 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 4 a 6 semanas', score:2, max: 5}))}>De 4 a 6 semanas</Button>
                  <Button className={`answer ${dataQuestions[3].answer=='De 7 a 9 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 7 a 9 semanas', score:3, max: 5}))}> De 7 a 9 semanas</Button>
                  <Button className={`answer ${dataQuestions[3].answer=='De 10 a 12 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'De 10 a 12 semanas', score:4, max: 5}))}> De 10 a 12 semanas</Button>
                  <Button className={`answer ${dataQuestions[3].answer=='Más de 12 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'Más de 12 semanas', score:5, max: 5}))}>Más de 12 semanas</Button>   
              </div>
                  <h3 className="question">P: ¿En qué plazo desea planificar su ciclo de mantenimiento?</h3>
                  <div className="answers">
                  <Button className={`answer ${dataQuestions[4].answer=='De 1 a 3 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'De 1 a 3 semanas', score:'De 1 a 3 semanas' === dataQuestions[3].answer?4:2, max: 4}))}>De 1 a 3 semanas</Button>
                  <Button className={`answer ${dataQuestions[4].answer=='De 4 a 6 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'De 4 a 6 semanas', score:'De 4 a 6 semanas' === dataQuestions[3].answer?4:2, max: 4}))}>De 4 a 6 semanas</Button>
                  <Button className={`answer ${dataQuestions[4].answer=='De 7 a 9 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'De 7 a 9 semanas', score:'De 7 a 9 semanas' === dataQuestions[3].answer?4:2, max: 4}))}>De 7 a 9 semanas</Button>
                  <Button className={`answer ${dataQuestions[4].answer=='De 10 a 12 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'De 10 a 12 semanas', score:'De 10 a 12 semanas' === dataQuestions[3].answer?4:2, max: 4}))}>De 10 a 12 semanas</Button>
                  <Button className={`answer ${dataQuestions[4].answer=='Más de 12 semanas'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'Más de 12 semanas', score:'Más de 12 semanas' === dataQuestions[3].answer?4:2, max: 4}))}>Más de 12 semanas</Button>   
                  </div>
              
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button" onClick={() => dispatch(nextPage())}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
            </div>
          )}
          {page === 5 && (
              <div className="questions">
                  <h3 className="question">P: ¿Tiene problemas con la confiabilidad/repetibilidad de las mediciones de las pruebas?</h3>
                  <div className="answers">
                      <Button className={`answer ${dataQuestions[5].answer=='Sí'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'Sí', score:2, max: 4}))}>Sí</Button>
                      <Button className={`answer ${dataQuestions[5].answer=='No'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'No', score:4, max: 4}))}>No</Button>
              </div>
              
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Anterior</span></Button>
                  <Button className="next_button"  component={Link} to={'/expertise'}><span>Siguiente</span><ArrowForwardIos /></Button>
              </div>
              <div>
                  <Button component={Link} to='/results' className="next_button view_results">Ver los resultados de la sección</Button>
              </div>
            </div>
          )}
        </div>
      </div>
      {page === 2 && (
      <SlideOut title={reduceRisk.title} copy={reduceRisk.copy}   stat={reduceRisk.stat}/>
    )}
      {page === 3 && (
      <SlideOut title={increaseConfidence.title} copy={increaseConfidence.copy}  bullets={increaseConfidence.bullets} view={increaseConfidence.view}/>
    )}
      {page === 4 && (
      <SlideOut title={troubleshootQuicker.title} copy={troubleshootQuicker.copy}   bullets={troubleshootQuicker.bullets} view={troubleshootQuicker.view}/>
    )}
      {page === 5 && (
      <SlideOut title={reduceDowntime.title} copy={reduceDowntime.copy}  bullets={reduceDowntime.bullets} view={reduceDowntime.view}/>
    )}
      <SideNav />
    </div>
    </Container>
  );
};

export default Data;
